import React from 'react';

// Function to get the day of the week correctly
const getDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { weekday: 'long' });
};

// Function to format date with the day of the week
const formatDateWithDay = (dateRangeString) => {
    let fullDate = '';
    // Check if it's a date range or single date
    if (dateRangeString.includes('–')){ 
        const startDate = dateRangeString.split('–')[0].trim();
        const yearMatch = dateRangeString.match(/\b\d{4}\b/);
        const year = yearMatch ? yearMatch[0] : new Date().getFullYear(); // Default to current year if not found
        fullDate = new Date(`${startDate} ${year}`);
    }
    else {
        fullDate = new Date(dateRangeString);
    }
    const dayOfWeek = getDayOfWeek(fullDate.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' }));
    return `${dayOfWeek}, ${dateRangeString}`;
};

 // Function to format the time
 const formatEventTime = (time) => {
    if (time && time.includes('–')) {
        const [startTime, endTime] = time.split('–');
        return (
            <>
                <strong>{startTime}</strong> {endTime}
            </>
        );
    }
    return <strong>{time}</strong>;
};

const VariantTwo = ({ results, matchesMedium }) => {
    console.log(results);
    // Sort the results array by date in ascending order
    const sortedResults = results.sort((a, b) => new Date(a.date) - new Date(b.date));
    
    // Group the results by date
    const groupedResults = sortedResults.reduce((acc, event) => {
        if (!acc[event.date]) {
            acc[event.date] = [];
        }
        acc[event.date].push(event);
        return acc;
    }, {});
    return (
        <div className="dynamic-events-listing__variant-two-parent">
            <section className="dynamic-events-listing">
                <table className="dynamic-events-listing__table">
                    <tbody>
                        {Object.keys(groupedResults).map((date, index) => (
                            <React.Fragment key={index}>
                                <tr>
                                    <td className="dynamic-events-listing__date-row" colSpan="2">
                                        <div className="dynamic-events-listing__event-date">{formatDateWithDay(date)}</div>
                                    </td>
                                </tr>
                                {groupedResults[date].map((event, eventIndex) => (
                                    <tr key={eventIndex}>
                                        <td className="dynamic-events-listing__table-col">
                                            <span className="dynamic-event-listing__title">
                                                {event.title}
                                                {event.facultyLocation && (
                                                    <span className="dynamic-events-listing__faculty-loc"> / {event.facultyLocation}</span>
                                                )}
                                            </span>
                                            <br />
                                            <span className="dynamic-events-listing__description">{event.description}</span>
                                            <br />
                                            <span className="dynamic-events-listing__department-type">
                                                {event.department && event.department}
                                                {event.department && event.type && " / "}
                                                {event.type && event.type}
                                            </span>
                                            <br />
                                            <span className="dynamic-event-listing__location">{event.locationOne}</span>
                                        </td>
                                        <td className="dynamic-events-listing__table-col">
                                            <span className="dynamic-events-listing__event-time">
                                                {formatEventTime(event.time)}{" "}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </section>
        </div>
    );
};

export default VariantTwo;
